import React, { useState, useEffect } from 'react';
import { Auth } from 'aws-amplify';
import { get } from 'lodash';
import { bool, object, func, array } from 'prop-types';
import { Drawer, DrawerHeader, Column } from '../../common';
import ModifyShipping from '../ModifyShipping/ModifyShipping';

const DrawerReschedulingMassive = ({ opened, setOpened, selectedOrders, orderData }) => {
    const [currentUserInfo, setCurrentUserInfo] = useState({});
    const { email } = get(currentUserInfo, 'idToken.payload', { email: 'Sin email' });

    useEffect(() => {
        async function getCurrentSession () {
            const response = await Auth.currentSession();
            setCurrentUserInfo(response);
        };

        getCurrentSession();
    }, []);

    return <Drawer
        values={['25%', '25%', '100%']}
        visible={opened}
        onClose={() => setOpened(false)}
        minWidth='311px'
    >
        <Column>
            <DrawerHeader
                title={'Reprogramación Masiva'}
                subtitle={get(orderData, 'logisticsInfo.selectedSla', '')}
                onClose={() => setOpened(false)}
            />
            <ModifyShipping
                orderIds={selectedOrders}
                fromMassiveActions
                onCancel={() => setOpened(false)}
                email={email}
                {...orderData}
            />
        </Column>
    </Drawer>;
};

DrawerReschedulingMassive.propTypes = {
    selectedOrders: array,
    opened: bool,
    setOpened: func,
    orderData: object
};

export default DrawerReschedulingMassive;
